import { useEffect, useState } from 'react';

import { Chat } from '@mint-sdk/api-ai-assistant';
import { useNavigate } from '@mint/routing';
import { useSetAtom } from 'jotai';

import { isS2SAtom } from '../assistant/atoms/chat.js';
import { useChatHistoryState } from './useChatHistoryState.jsx';
import { useStubMessage } from './useStubMessage.jsx';

export const useStartNewChat = () => {
  const navigate = useNavigate();
  const [isPending, setIsPending] = useState(false);
  const { addNewMsgToLocalState } = useChatHistoryState();
  const { createStubMessage } = useStubMessage();
  const { mutateAsync: startChatMutation } = Chat.createChat();
  const setIsS2S = useSetAtom(isS2SAtom);

  useEffect(() => {
    return () => {
      setIsPending(false);
    };
  }, []);

  const startNewChat = async (
    chatMeta: Chat.ChatDetailsQueryType,
    userMessage: { text: string; metadata?: Chat.UserMetadataSchemaType },
  ) => {
    setIsPending(true);

    const data = await startChatMutation({
      data: chatMeta,
    });
    const { chatSessionId } = data;

    const prompt = createStubMessage(userMessage);
    addNewMsgToLocalState(chatSessionId, prompt);

    return data;
  };

  const startVoiceChat = async () => {
    setIsS2S(true);
    setIsPending(true);

    const { chatSessionId } = await startChatMutation({
      data: { scopeType: 'PAGE', scopePath: 'ai-hub' },
    });

    navigate({
      to: '/ai-hub/$chatId',
      params: { chatId: chatSessionId },
      search: { voiceMode: true },
      mask: {
        unmaskOnReload: true,
        to: '/ai-hub/$chatId',
        params: { chatId: chatSessionId },
      },
    });
  };

  return { startNewChat, startVoiceChat, isPending };
};
